import newFetch from './fetch';
import analyticsHook from '../analytics/ga/http';
import { logger, sentryHook } from '../http/middleware';

export function getFetchAPI() {
    let http = newFetch( window.location.origin );

    if ( process.env.HTTP_LOGGING === 'true' ) {
        http = logger( http );
    }

    http = sentryHook( http );

    http = analyticsHook( http );

    return http;
}
